
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ChevronLeft } from "lucide-react";
import {
  getCookie,
  setCookie,
  setCookieToken,
  setCookieUserId,
} from "../utils/helper";
import { loginApi, matchOtpApi, matchSubscribeOtpApi } from "../http/http";
import ModalInfo from "../components/ModalInfo";
import Loader from "../components/Loader";
import Cookies from "js-cookie";
import { useRedirect } from "../context/redirectContext";
import CongratsModal from "../components/CongratsModal";


const OtpPage = () => {
  const [otp, setOTP] = useState("");
  const [timer, setTimer] = useState(60);
  const navigate = useNavigate();
  const [msisdn, setMsisdn] = useState("");
  const [pack, setPack] = useState("");
  const [currency, setCurrency] = useState("");
  const [resend, setResend] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalInfo, setModalInfo] = useState("");
  const [loading, setLoading] = useState(false);
  const { setredirectURL } = useRedirect();
  const [deviceId, setDeviceId] = useState('');
  const [congratsModal, setCongratsModal] = useState(false);
  const [wonPoints, setWonPoints] = useState(0);

  const handleCongratsClose = () => {
    setCongratsModal(false);
    setOTP("");
    navigate("/auth");
  };

  const pressHandler = () => {
    setModal(false);
    setModalInfo("");
  };


  const location = useLocation();
  const fromSubscription = location.state?.fromSubscription || false;
  useEffect(() => {
    const packSelected = location.state?.pack;
    const number = location.state?.msisdn;
    const currencySelected = location.state?.currency;
    const deviceId=location.state?.deviceId
    // console.log(location.state);
    setMsisdn(number);
    setPack(packSelected);
    setCurrency(currencySelected);
    setDeviceId(deviceId)
  }, [location.state]);

  useEffect(() => {
    if (timer <= 0) return;
    const countdown = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer <= 1) {
          clearInterval(countdown);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);
    return () => {
      clearInterval(countdown);
    };
  }, [timer]);

  const handleOtpChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,4}$/.test(value)) {
      setOTP(value);
    }
  };

  const getDisplayMsisdn = (msisdn) => {
    if (!msisdn) return "";
    return msisdn.startsWith("263") ? msisdn.slice(3) : msisdn;
  };

  const cleanPhoneNumber = (phone) => {
    let cleaned = String(phone).replace(/\D/g, "");
    if (cleaned.startsWith("263")) {
      cleaned = cleaned.slice(3);
    }
    if (cleaned.startsWith("0")) {
      cleaned = cleaned.slice(1);
    }
    return `263${cleaned}`;
  };

  const otpHandler = async () => {
    try {
      if (otp.length !== 4) {
        setModal(true);
        setModalInfo("Enter a valid OTP number of 4 digits!");
        return;
      }

      try {
        setLoading(true);
        const payload = {
          msisdn: Number(cleanPhoneNumber(msisdn)),
          otp: otp,
          currency: currency,
          deviceId:deviceId
        };

        const Subacriptionpayload = {
          msisdn: Number(cleanPhoneNumber(msisdn)),
          otp: otp,
          currency: currency,
          deviceId:deviceId,
          pack:pack

        };

        const response = fromSubscription
          ? await matchSubscribeOtpApi(Subacriptionpayload) // subscription-verify
          : await matchOtpApi(payload); // verify-otp
        if (response.status === 200) {
          setLoading(false);
          localStorage.setItem("currency", currency);
          const redirectUrl = response?.data?.message;
          const token = response?.data?.token;
          const rewardStatus = response?.data?.rewardsStatus !== undefined ? response?.data?.rewardsStatus : response?.data?.rewardStatus;
          const rewardsPoints = response?.data?.rewardsPoints !== undefined ? response?.data?.rewardsPoints : response?.data?.rewardStatusPoints;
          const canClaimRewards = response?.data?.canClaimRewards;
          const canClaimPoints = response?.data?.canClaimPoints;

          localStorage.setItem("redirectUrl", redirectUrl);
          localStorage.setItem("msisdn", cleanPhoneNumber(msisdn));
          localStorage.setItem("deviceId", deviceId);
          localStorage.setItem("token", token);
          localStorage.setItem("rewardsPoints", String(rewardsPoints || 0));
          localStorage.setItem("canClaimRewards", String(canClaimRewards !== undefined ? canClaimRewards : false));
          localStorage.setItem("canClaimPoints", String(canClaimPoints !== undefined ? canClaimPoints : (rewardsPoints || 0)));

          if (rewardStatus === true || rewardStatus === "true") {
            setWonPoints(rewardsPoints || 0);
            setCongratsModal(true);
          } else {
            setTimeout(() => {
              setOTP("");
              navigate("/auth");
            }, 3000);
          }
        } else {
          setLoading(false);
          setModal(true);
          setModalInfo("Wrong OTP");
        }

      } catch (error) {
        setLoading(false);

        const statusCode =
          error?.response?.data?.statusCode || error?.response?.status;

        if (statusCode == 403) {
          setModal(true);
          setModalInfo(
            error?.response?.data?.message ||
              "Please top up your airtime and try again to continue enjoying the service.",
          );
          setTimeout(() => navigate(-1), 5000);
        } else if (statusCode == 400) {
          setModal(true);
          setModalInfo(error?.response?.data?.message || "Invalid Otp");
        } else {
          setModal(true);
          setModalInfo("Wrong OTP");
        }

        // console.error(error);
      }
    } catch (error) {
      setLoading(false);
      setModal(true);
      setModalInfo("Wrong OTP");
    }
  };

  const resendHandler = async () => {
    try {
      setLoading(true);

      const response = await loginApi({
        msisdn,
        currency,
      });

      if (response.status === 200) {
        setResend(true);
        setTimer(60);
        toast.success("OTP sent again");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to resend OTP");
    } finally {
      setLoading(false);
    }
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  return (
    <div className="min-h-screen bg-white flex flex-col md:block">
      {/* Mobile view - completely unchanged */}
      <div className="md:hidden w-full max-w-[430px] min-h-screen bg-white flex flex-col mx-auto">
        <div className="px-6 py-8 flex flex-col flex-1 max-w-[320px] mx-auto w-full">
          <div className="flex items-center justify-between mb-8 w-full">
            <button
              onClick={() => navigate(-1)}
              className="text-xl bg-transparent border-2 border-black rounded-lg cursor-pointer w-10 h-10 flex items-center justify-center text-black shrink-0"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <div className="flex items-center gap-4 w-full justify-end pr-2">
              <img src="/yogamezxr.png" style={{ mixBlendMode: 'multiply' }} className="h-8 sm:h-12 w-auto object-contain max-w-[40%]" alt="YoGamesXR Logo" />
              <img src="/assets/images/econet_logo.png" className="h-8 sm:h-12 w-auto object-contain max-w-[40%]" alt="Econet Logo" />
            </div>
          </div>

          <div className="flex flex-col gap-8">
            <div className="text-left">
              <h1 className="text-[28px] font-bold text-[#3CB8D4] mb-0 leading-tight">
                Please check your
                <br />
                sms
              </h1>
              <p className="pt-4 text-xl font-semibold">Enter the OTP</p>
            </div>

            <input
              type="text"
              inputMode="numeric"
              maxLength={4}
              value={otp}
              onChange={handleOtpChange}
              placeholder=""
              className="w-full h-14 text-3xl font-semibold text-center bg-transparent text-black outline-none rounded-none tracking-[1rem]"
              style={{ border: "none", borderBottom: "2px solid #9ca3af" }}
            />

            <button
              onClick={otpHandler}
              className="w-full py-4 bg-[#3CB8D4] text-black border-none rounded-lg text-base font-semibold cursor-pointer"
            >
              Verify OTP
            </button>

            <div className="text-center">
              <button
                onClick={timer === 0 ? resendHandler : undefined}
                className={`text-base bg-transparent border-none transition-all ${
                  timer === 0
                    ? "text-black cursor-pointer"
                    : "text-gray-400 cursor-default"
                }`}
              >
                Send code again{" "}
                {timer > 0 && (
                  <span className="font-normal">{formatTime(timer)}</span>
                )}
              </button>
            </div>
          </div>
        </div>

        {loading && <Loader />}
        {modal && <ModalInfo text={modalInfo} pressHandler={pressHandler} />}
      </div>

      {/* PC view */}
      <div className="hidden md:flex min-h-screen bg-white">
        <div className="w-full flex flex-col py-[4vh]">
          <div className="flex items-center gap-8 mb-[3vh]" style={{ paddingLeft: "25%" }}>
            <img src="/yogamezxr.png" style={{ mixBlendMode: 'multiply' }} className="h-12 md:h-16 w-auto object-contain max-w-[200px]" alt="YoGamesXR Logo" />
            <img src="/assets/images/econet_logo.png" className="h-12 md:h-16 w-auto object-contain max-w-[200px]" alt="Econet Logo" />
          </div>
          <div className="mb-[3vh]" style={{ paddingLeft: "25%" }}>
            <h1
              style={{ fontSize: "clamp(22px, 2.8vw, 52px)" }}
              className="font-bold text-[#3CB8D4] mb-0 leading-tight"
            >
              Please check your sms
            </h1>
            <p
              style={{ fontSize: "clamp(14px, 1.3vw, 26px)" }}
              className="pt-4 font-semibold"
            >
              Enter the OTP
            </p>
          </div>

          <div className="flex flex-col items-center w-full">
            <div
              className="flex flex-col"
              style={{
                gap: "clamp(16px, 2vh, 32px)",
                width: "clamp(220px, 20vw, 380px)",
              }}
            >
              <button
                onClick={() => navigate(-1)}
                className="self-start text-xl bg-transparent border-2 border-black rounded-lg cursor-pointer w-10 h-10 flex items-center justify-center text-black"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>

              <input
                type="text"
                inputMode="numeric"
                maxLength={4}
                value={otp}
                onChange={handleOtpChange}
                placeholder=""
                style={{
                  fontSize: "clamp(20px, 2vw, 36px)",
                  borderBottom: "2px solid #9ca3af",
                }}
                className="w-full h-[7vh] font-semibold text-center bg-transparent text-black outline-none rounded-none tracking-[1rem] "
              />

              <button
                onClick={otpHandler}
                style={{
                  fontSize: "clamp(13px, 1.1vw, 20px)",
                  padding: "clamp(10px, 1.5vh, 18px)",
                }}
                className="w-full bg-[#3CB8D4] text-black border-none rounded-lg font-semibold cursor-pointer"
              >
                Verify OTP
              </button>

              <div className="text-center">
                <button
                  onClick={timer === 0 ? resendHandler : undefined}
                  style={{ fontSize: "clamp(12px, 1vw, 18px)" }}
                  className={`bg-transparent border-none transition-all ${timer === 0 ? "text-black cursor-pointer" : "text-gray-400 cursor-default"}`}
                >
                  Send code again{" "}
                  {timer > 0 && (
                    <span className="font-normal">{formatTime(timer)}</span>
                  )}
                </button>
              </div>
            </div>
          </div>
          {loading && <Loader />}
        </div>

        {modal && <ModalInfo text={modalInfo} pressHandler={pressHandler} />}
      </div>
      <CongratsModal isOpen={congratsModal} points={wonPoints} onClose={handleCongratsClose} />
    </div>
  );

};

export default OtpPage;
